import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'insuranceClass',
  standalone: true
})
export class InsuranceClassPipe implements PipeTransform {
  transform(classNumber: number | string | null): string {
    if (!classNumber) return 'N/A';
    
    const classMap: Record<string, string> = {
      '1': 'VIP',
      '2': 'A',
      '3': 'B',
      '4': 'C',
      '5': 'Basic'
    };
    
    return classMap[classNumber.toString()] || classNumber.toString();
  }
}